import colors from 'assets/styles/jsVariables/colors';

export const style = {
  palette: {
    primary: {
      main: colors.lighterCyan,
      light: colors.lightPurple
    },
    secondary: {
      main: colors.mediumGrey,
      light: colors.lightGrey
    }
  },
  props: {
    MuiButtonBase: {
      disableRipple: true
    },
  },
  overrides: {
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: '2px solid #00af9f'
        },
        '&:before': {
          borderBottom: '1px solid rgb(224, 224, 224)'
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: '1px solid rgb(224, 224, 224) !important'
        }
      }
    },
    MuiButton: {
      label: {
        color: 'white',
        letterSpacing: '1px',
        fontSize: '14px',
      },
      root: {
        borderRadius: 10,
      }
    },
    MuiTypography: {
      subheading: {
        color: colors.darkGrey,
      },
    },
    MuiDialogActions: {
      root: {
        margin: '8px'
      }
    }
  },
  typography: {
    fontFamily: [
      'proxima_novaregular',
      'Arial',
      'Helvetica Neue',
      'Helvetica',
      'sans-serif'
    ].join(',')
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/assets/styles/styles.js